export default __webpack_public_path__ + "static/media/topseller.84509e9a.png";